import * as userService from "./user.service";

const INITIAL_STATE = {
  // 令牌信息
  tokenInfo: {
    token: "",
  },
  // 用户信息
  userInfo: {},
};

const user = {
  state: {
    ...INITIAL_STATE,
  },
  actions: {
    login({ dispatch }, loginInfo) {
      return userService.login(loginInfo).then(res => {
        dispatch({ type: "user/login", payload: res.data });
        return res;
      });
    },
    logout({ dispatch }) {
      return userService.logout().then((res) => {
        dispatch({ type: "user/logout", payload: {} });
        return res;
      });
    },
    getUserInfo({ dispatch }) {
      return userService.getUserInfo().then((res) => {
        dispatch({ type: "user/getUserInfo", payload: res.data, });
        return res;
      });
    },
    checkLogin({ dispatch }, param) {
      return userService.checkLogin(param).then((res) => {
        const { login } = res.data;
        if (login) {
          const { token } = param;
          dispatch({ type: "user/checkLogin", payload: { token }, });
        }
        return res;
      });
    },
  },
  reducers: {
    login(prevState, payload) {
      const { tokenHead, token } = payload;
      return {
        ...prevState,
        tokenInfo: { ...prevState.tokenInfo, token: `${tokenHead}${token}` }
      };
    },
    getUserInfo(prevState, payload) {
      return {
        ...prevState,
        userInfo: { ...payload }
      };
    },
    logout(prevState, payload) {
      return { ...INITIAL_STATE };
    },
    checkLogin(prevState, payload) {
      const { token } = payload;
      return {
        ...prevState,
        tokenInfo: { token }
      };
    },
  }
}

export default user;
